<template>
  <div>
    <div id="myReferer" style="height:248px;width:100%;"></div>
  </div>
</template>

<script>
import echarts from "echarts";

export default {
  name: "RefererChart",
  data() {
    return {
      chartData: [],
      firstShow: true,
    };
  },
  props: {
    travelModeInfo: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  watch: {
    travelModeInfo(newValue, oldValue) {
      if (newValue.length == 0) {
        this.chartData = [
          { name: "", value: 0, itemStyle: { color: "#DCDDE0" } },
        ];
      } else {
        this.chartData = newValue;
      }
      this.drawLine();
      this.firstShow = false;
    },
  },
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myReferer = echarts.init(document.getElementById("myReferer"));
      // 绘制图表
      myReferer.setOption({
        tooltip: {
          trigger: "item",
          triggerOn: 'click',
          formatter: function(params) {
            return `
              <div>${params.name}: ${params.percent}%</div>
            `
          }
        },
        legend: {
          show: false,
        },
        series: [
          {
            name: "",
            type: "pie",
            show: false,
            hoverAnimation: false,
            radius: ["35.5%", "54.8%"],
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              position: 'outer',
              formatter: "{name|{b}}\n{percent|{d} %}\n",
              // formatter: (params) => {
              //   console.log('1111', params)
              //   return `${params.name.substr(0, params.name.length - 1)}\n${params.percent}%`
              //   return `<p>${params.name.substr(0, params.name.length - 1)}</p><p>${params.percent}%</p> `
              // },
              rich: {
                name: {
                  width: "100%",
                  textAlign: "center",
                  fontSize: 12,
                  color: "#71747A",
                },
                percent: {
                  width: "100%",
                  textAlign: "center",
                  lineHeight: 23,
                  fontSize: 12,
                  fontWeight: "bold",
                  color: "#1E2226",
                },
              }
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: "#DCDDE0",
                },
              },
            },
            data: this.chartData,
          },
        ],
      });
    },
  },
};
</script>
